module.exports = __webpack_public_path__ + "img/x2.5e90e857.svg";